import { useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import OrganisationList from '../organisation/OrganisationList';
import OrganisationAdd from '../organisation/OrganisationAdd';
import OrganisationMain from '../organisation/OrganisationMain';
import TerminalEdit from "../terminal/TerminalEdit";
import UnitEdit from "../unit/UnitEdit";
import UnitAdd from "../unit/UnitAdd";
import Header from './Header';
import Home from "./Home";
import TerminalAdd from "../terminal/TerminalAdd"
import CapabilityEdit from "../capability/CapabilityEdit";
import StationEdit from "../station/StationEdit";
import CapabilityAdd from "../capability/CapabilityAdd";
import StationAdd from "../station/StationAdd";
import LoginPage from "../login/LoginPage";
import { AuthContext } from "../AuthContext";
import UserEdit from '../user/UserEdit';
import UserAdd from '../user/UserAdd';
import UnitMissionCapabilityEdit from '../capability/UnitMissionCapabilityEdit';
import UnitMissionCapabilityAdd from '../capability/UnitMissionCapabilityAdd';
import SetPasswordPage from '../password/SetPasswordPage';
import ForgotPasswordPage from '../password/ForgotPasswordPage';
import PrivacyPolicyPage from '../privacypolicy/PrivacyPolicyPage';
import VersionHistoryPage from '../versionhistory/VersionHistoryPage';
import UserGroupEdit from '../usergroup/UserGroupEdit';
import UserGroupAdd from '../usergroup/UserGroupAdd';
import UserImport from '../user/UserImport';

function App() {
  const [token, setToken] = useState('');
  const [refreshToken, setRefreshToken] = useState('');
  const [roles, setRoles] = useState<string[]>([]);
  const [usersName, setUsersName] = useState('');
  const [organisationName, setOrganisationName] = useState('');
  const [organisationId, setOrganisationId] = useState('');
  const [userId, setUserId] = useState('');
  const [selectedStationId, setSelectedStationId] = useState('all');

  return (
      <BrowserRouter>
        <ToastContainer 
        autoClose={1000}
        hideProgressBar={true}
        position="top-center"
      />
      <AuthContext.Provider value={{ token, refreshToken, roles, usersName, organisationId, organisationName, userId, setToken, setRefreshToken, setRoles, setUsersName, setOrganisationId, setOrganisationName, setUserId }}>
        <div >
                  <Header subtitle="Management portal" onLogOut={() => setSelectedStationId("all")} />
          <div className="container flex-column align-items-center">
          {/* <Breadcrumbs /> */}
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/home" element={<Home />} />
            <Route path="/organisation" element={<OrganisationList />} />
            <Route path="/organisation/add" element={<OrganisationAdd />} />
                          <Route path="/organisation/:organisationId" element={<OrganisationMain selectedStationId={selectedStationId} selectedStationIdChanged={(s) => setSelectedStationId(s) } />} />
            <Route path="/organisation/:organisationId/unit/:unitId" element={<UnitEdit />} />
            <Route path="/organisation/:organisationId/unit/add" element={<UnitAdd />} />
            <Route path="/organisation/:organisationId/unit/:unitId/terminal/:terminalId" element={<TerminalEdit />} />
            <Route path="/organisation/:organisationId/unit/:unitId/terminal/add" element={<TerminalAdd />} />
            <Route path="/organisation/:organisationId/capability/:capabilityId" element={<CapabilityEdit />} />
            <Route path="/organisation/:organisationId/capability/add" element={<CapabilityAdd />} />
            <Route path="/organisation/:organisationId/usergroup/:userGroupId" element={<UserGroupEdit />} />
            <Route path="/organisation/:organisationId/usergroup/add" element={<UserGroupAdd />} />
            <Route path="/organisation/:organisationId/station/:stationId" element={<StationEdit />} />
            <Route path="/organisation/:organisationId/station/add" element={<StationAdd />} />
            <Route path='/organisation/:organisationId/user/:userId' element={<UserEdit/>} />
            <Route path='/organisation/:organisationId/user/add' element={<UserAdd />} />
            <Route path='/organisation/:organisationId/user/storeimport' element={<UserImport />} />
            <Route path='/organisation/:organisationId/unitmissioncapability' element={<UnitMissionCapabilityEdit />} />
            <Route path='/organisation/:organisationId/unitmissioncapability/add' element={<UnitMissionCapabilityAdd />} />
            <Route path='/set-password' element={<SetPasswordPage />} />
            <Route path='/forgot-password' element={<ForgotPasswordPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
            <Route path='/version-history' element={<VersionHistoryPage />} />
          </Routes>
          </div>
        </div>
        </AuthContext.Provider>
      </BrowserRouter>
    );
  }

export default App;